import { FC } from 'react'
import { useMessage } from '@pepper/ui'
import clsx from 'clsx'

import ContentGapBanner from 'assets/images/contentGap/content-gap.png'
import GoogleIntegrationButton from 'components/GoogleIntegrationButton'
import { useSelectedCompanyId } from 'utils/functions/misc'

import s from './Banner.module.css'

type Props = {
  tab: 'DOMAIN_REFRESH' | 'URL_REFRESH'
  handleRefetch?: () => void
}

export const Banner: FC<Props> = ({ tab, handleRefetch }) => {
  const companyId = useSelectedCompanyId()

  const { showError } = useMessage()

  return (
    <div className={s.wrapper} data-id="refresh-connect-google-banner">
      <div className={s.icon}>✨</div>
      <div>
        <div className={s.title}>connect your gsc account</div>
        <div
          className={clsx(s.header, {
            [s.bold]: tab === 'URL_REFRESH',
          })}
        >
          {tab === 'URL_REFRESH'
            ? 'Let Pepper help you get more traffic'
            : 'Pepper AI can identify refresh opportunities for you'}
        </div>
        <div className={s.subHeader}>
          Let our platform quickly identify which content on your website has
          the <br /> potential to perform better, saving you time and effort.
        </div>

        <GoogleIntegrationButton
          companyId={companyId}
          onError={error => showError(error)}
          cta="Connect GSC account"
          onSuccess={handleRefetch}
          type="ghost"
        />
      </div>
      <div className={s.imageWrapper}>
        <img
          src={ContentGapBanner}
          className={s.contentGapImage}
          alt="content-gap"
        />
      </div>
    </div>
  )
}
